<div class="split-auth-container">
  <!-- Left Panel -->
  <div class="split-left-panel">
    <div class="split-left-bg">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="split-left-img">
      <div class="split-left-overlay"></div>
    </div>
    <div class="split-left-content">
      <span class="left-tagline">A Heritage of Love</span>
      <h1 class="left-title">Find Your Perfect Life Partner</h1>
      <p class="left-desc">
        Experience a matrimonial journey built on tradition, family values, and curated connections. Where heritage meets modern search capabilities.
      </p>
      
      <div class="trust-badge-list">
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">verified_user</span>
          <div class="badge-text">
            <h4>Verified Profiles</h4>
            <p>Every account goes through a thorough check for secure matchmaking</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">chat</span>
          <div class="badge-text">
            <h4>Secure Messaging</h4>
            <p>Your privacy and safety are always our top concern</p>
          </div>
        </div>
        <div class="trust-badge-item">
          <span class="material-symbols-outlined icon">shield</span>
          <div class="badge-text">
            <h4>Privacy Protected</h4>
            <p>Full control over your photos and profile visibility</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Panel -->
  <div class="split-right-panel">
    <!-- Mobile-only Banner -->
    <div class="mobile-onboarding-banner">
      <img src="assets/images/wedding.jpg" alt="Wedding Couple" class="mobile-banner-img">
      <div class="mobile-banner-overlay"></div>
      <div class="mobile-banner-text">
        <span class="left-tagline">A Heritage of Love</span>
        <h3>Find Your Perfect Partner</h3>
      </div>
    </div>

    <div class="onboarding-card">
      <div class="auth-header">
        <a routerLink="/" class="logo">Weddingly Matrimony</a>
        
        <!-- Progress Stepper -->
        <div class="step-progress-wrapper">
          <span class="progress-step-text">Step 1 of 4: Basic Details</span>
          <div class="stepper-bar">
            <div class="stepper-progress" style="width: 25%;"></div>
          </div>
        </div>

        <h2>Begin Your Story</h2>
        <p>Create your profile and start searching for connections</p>
      </div>

      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="row">
          <div class="col-md-6 form-group">
            <label for="first_name">First Name</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">person</span>
              <input 
                type="text" 
                id="first_name" 
                formControlName="first_name" 
                class="warm-input" 
                placeholder="John"
                [class.invalid]="signupForm.get('first_name')?.touched && signupForm.get('first_name')?.invalid"
              >
            </div>
            <span class="error-msg" *ngIf="signupForm.get('first_name')?.touched && signupForm.get('first_name')?.invalid">
              First name is required
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label for="last_name">Last Name</label>
            <div class="input-with-icon">
              <span class="material-symbols-outlined input-icon">person</span>
              <input 
                type="text" 
                id="last_name" 
                formControlName="last_name" 
                class="warm-input" 
                placeholder="Doe"
                [class.invalid]="signupForm.get('last_name')?.touched && signupForm.get('last_name')?.invalid"
              >
            </div>
            <span class="error-msg" *ngIf="signupForm.get('last_name')?.touched && signupForm.get('last_name')?.invalid">
              Last name is required
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <label for="date_of_birth">Date of Birth</label>
            <app-dob-picker
              formControlName="date_of_birth"
              customClass="warm-input"
              [showIcon]="true"
              [hasError]="!!(signupForm.get('date_of_birth')?.touched && signupForm.get('date_of_birth')?.invalid)"
            ></app-dob-picker>
            <span class="error-msg" *ngIf="signupForm.get('date_of_birth')?.touched && signupForm.get('date_of_birth')?.invalid">
              <span *ngIf="signupForm.get('date_of_birth')?.hasError('required')">DOB is required</span>
              <span *ngIf="signupForm.get('date_of_birth')?.hasError('underAge')">You must be at least 18 years old</span>
            </span>
          </div>

          <div class="col-md-6 form-group">
            <label>Gender</label>
            <div class="gender-radio-group">
              <label class="radio-label">
                <input type="radio" formControlName="gender" value="Male">
                <span>Male</span>
              </label>
              <label class="radio-label">
                <input type="radio" formControlName="gender" value="Female">
                <span>Female</span>
              </label>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="language">Mother Tongue</label>
        
          <div class="input-with-icon custom-dropdown">
        
            <span class="material-symbols-outlined input-icon">
              language
            </span>
        
            <!-- Selected value box -->
            <div class="warm-input selected-box" (click)="openLanguageDropdown()">
        
              {{selectedLanguageName || 'Select language'}}
        
              <span class="arrow">▼</span>
        
            </div>
        
        
            <!-- Dropdown -->
            <div class="language-list" *ngIf="showLanguageList">
        
        
              <!-- Search tab -->
              <input type="text" class="search-box" placeholder="Search here" (input)="searchLanguage($event)"
                (click)="$event.stopPropagation()">
        
        
              <!-- Languages -->
              <div class="language-item" *ngFor="let lang of filteredLanguages" (click)="selectLanguage(lang)">
        
                {{lang.language_nme}}
        
              </div>
        
        
            </div>
        
          </div>
        
        
          <span class="error-msg" *ngIf="signupForm.get('language')?.touched && signupForm.get('language')?.invalid">
            Language is required
          </span>
        
        </div>

        <div class="form-group">
          <label for="email">Email Address</label>
          <div class="input-with-icon">
            <span class="material-symbols-outlined input-icon">mail</span>
            <input 
              type="email" 
              id="email" 
              formControlName="email" 
              class="warm-input" 
              placeholder="john.doe@domain.com"
              [class.invalid]="signupForm.get('email')?.touched && signupForm.get('email')?.invalid"
            >
          </div>
          <span class="error-msg" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('required')">
            Email is required
          </span>
          <span class="error-msg" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('email')">
            Invalid email format
          </span>
        </div>

        <div class="form-group">
          <label for="phone">Phone Number</label>
          <div class="input-with-icon">
            <span class="material-symbols-outlined input-icon">call</span>
            <input 
              type="tel" 
              inputmode="numeric"
              maxlength="10"
              id="phone" 
              formControlName="phone" 
              class="warm-input" 
              placeholder="9876543210"
              (input)="onPhoneInput($event)"
              [class.invalid]="signupForm.get('phone')?.touched && signupForm.get('phone')?.invalid"
            >
          </div>
          <span class="error-msg" *ngIf="signupForm.get('phone')?.touched && signupForm.get('phone')?.hasError('required')">
            Phone number is required
          </span>
          <span class="error-msg" *ngIf="signupForm.get('phone')?.touched && signupForm.get('phone')?.hasError('pattern')">
            Please enter a valid 10-digit phone number
          </span>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <div class="input-with-icon">
            <span class="material-symbols-outlined input-icon">lock</span>
            <input 
              type="password" 
              id="password" 
              formControlName="password" 
              class="warm-input" 
              placeholder="Min 8 characters"
              [class.invalid]="signupForm.get('password')?.touched && signupForm.get('password')?.invalid"
            >
          </div>
          <span class="error-msg" *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.hasError('required')">
            Password is required
          </span>
          <span class="error-msg" *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.hasError('minlength')">
            Password must be at least 8 characters
          </span>
        </div>

        <button type="submit" class="gold-button submit-btn">
          <span>Continue</span>
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>

        <div class="trust-note">
          <span class="material-symbols-outlined trust-lock">lock</span>
          <span>Your information is private and secure</span>
        </div>
      </form>

      <div class="auth-footer">
        <p>Already have an account? <a routerLink="/login">Log in</a></p>
      </div>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════
     OTP VERIFICATION MODAL
═══════════════════════════════════════════════════════════════════════ -->
<div class="otp-overlay" *ngIf="showOtpModal" (click)="closeOtpModal()">
  <div class="otp-modal" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="otp-modal-header">
      <div class="otp-modal-icon">
        <span class="material-symbols-outlined">{{ otpStep === 'channel' ? 'sms' : 'verified' }}</span>
      </div>
      <div>
        <h2 class="otp-modal-title">{{ otpStep === 'channel' ? 'Choose Verification Method' : 'Verify Your Number' }}</h2>
        <p class="otp-modal-sub" *ngIf="otpStep === 'channel'">
          We will send a 6-digit verification code to <strong>+91 {{ signupForm.value.phone }}</strong>
        </p>
        <p class="otp-modal-sub" *ngIf="otpStep === 'verify'">
          We sent a 6-digit code via {{ otpChannel === 'whatsapp' ? 'WhatsApp' : 'SMS' }} to <strong>+91 {{ signupForm.value.phone }}</strong>
        </p>
      </div>
      <button class="otp-close-btn" (click)="closeOtpModal()" title="Cancel">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <!-- Channel Selector (always shown so user can switch channel cleanly) -->
    <div class="otp-channel-selector" *ngIf="otpStep === 'channel'">
      <button
        class="channel-btn"
        [class.channel-active]="otpChannel === 'sms'"
        (click)="selectChannel('sms')"
        [disabled]="otpSending">
        <span class="material-symbols-outlined">sms</span>
        SMS
      </button>
      <button
        class="channel-btn"
        [class.channel-active]="otpChannel === 'whatsapp'"
        (click)="selectChannel('whatsapp')"
        [disabled]="otpSending">
        <svg class="wa-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        WhatsApp
      </button>
    </div>

    <!-- Sending Spinner -->
    <div class="otp-sending-wrap" *ngIf="otpSending">
      <span class="material-symbols-outlined otp-spin">progress_activity</span>
      <span>Sending OTP via {{ otpChannel === 'whatsapp' ? 'WhatsApp' : 'SMS' }}…</span>
    </div>

    <!-- STEP 1: Send OTP Button (when on channel step and not sending) -->
    <button
      class="otp-verify-btn"
      (click)="sendOtp()"
      [disabled]="otpSending"
      *ngIf="otpStep === 'channel' && !otpSending">
      <span class="material-symbols-outlined">send</span>
      <!-- bypass otp this one line -->
      {{ isLocalhost ? 'Auto-verify OTP for localhost' : 'Send OTP via ' + (otpChannel === 'whatsapp' ? 'WhatsApp' : 'SMS') }} 
    </button>
    <!-- bypass otp added -->
    <p class="otp-error-msg" *ngIf="isLocalhost && otpStep === 'channel'">
      Localhost mode: OTP is auto-approved for testing.
    </p>
    <!-- upto this -->
    <!-- STEP 2: OTP Digits & Verification (when on verify step and not sending) -->
    <div class="otp-digits-wrap" *ngIf="otpStep === 'verify' && !otpSending">
      <div class="otp-digits">
        <input
          *ngFor="let d of otpDigits; let i = index; trackBy: trackByIndex"
          [id]="'otp-box-' + i"
          class="otp-digit"
          type="text"
          inputmode="numeric"
          maxlength="1"
          [value]="otpDigits[i]"
          (input)="onOtpInput($event, i)"
          (keydown)="onOtpKeydown($event, i)"
          (paste)="onOtpPaste($event)"
          autocomplete="one-time-code">
      </div>
      <p class="otp-expiry-note">
        <span class="material-symbols-outlined">schedule</span>
        Code expires in 5 minutes
      </p>
    </div>

    <!-- Error -->
    <div class="otp-error-msg" *ngIf="otpError">
      <span class="material-symbols-outlined">error</span>
      {{ otpError }}
    </div>

    <!-- STEP 2: Verify Button -->
    <button
      class="otp-verify-btn"
      (click)="verifyOtp()"
      [disabled]="!otpComplete || otpVerifying || otpSending"
      *ngIf="otpStep === 'verify' && !otpSending">
      <span class="material-symbols-outlined" [class.otp-spin]="otpVerifying">
        {{ otpVerifying ? 'progress_activity' : 'check_circle' }}
      </span>
      {{ otpVerifying ? 'Verifying…' : 'Verify & Create Account' }}
    </button>

    <!-- STEP 2: Resend & Switch Row -->
    <div class="otp-resend-row" *ngIf="otpStep === 'verify' && !otpSending">
      <span *ngIf="resendSeconds > 0" class="otp-resend-timer">
        Resend in <strong>{{ resendSeconds }}s</strong>
      </span>
      <button
        *ngIf="resendSeconds === 0"
        class="otp-resend-btn"
        (click)="resendOtp()">
        <span class="material-symbols-outlined">refresh</span>
        Resend OTP
      </button>
      <span class="otp-divider" *ngIf="resendSeconds === 0">•</span>
      <button
        *ngIf="resendSeconds === 0"
        class="otp-switch-btn"
        (click)="switchChannelFromVerify()">
        Try via {{ otpChannel === 'sms' ? 'WhatsApp' : 'SMS' }} instead
      </button>
    </div>

  </div>
</div>
